import React, { Component } from 'react';
import './style.css';
import { Trans, translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

class Confirm extends Component {
  render() {
    const { term, opposite } = this.props;
    const description = (
      <Trans i18nKey="confirm">
        Great. Now let's continue with <b>"{{ term }}"</b> and{' '}
        <b>"{{ opposite }}"</b>. Please use your intuition to evaluate a set of
        objects using the slides. There is no right and wrong here.
      </Trans>
    );

    return (
      <div className="card-body">
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question" style={{ marginBottom: '39px' }}>
          {description}
        </div>
        <div className="actions">
          <Link to={this.props.url}>
            <button className="btn btn-primary btn-round btn-next">
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Confirm));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/confirm.js